import * as utils from './utils';

const getOne = utils.getOne('users', '');

const provider = {
  getUserById: getOne,
};

export default provider;
